export const FOOTER_CONFIG = {
  payment_methods: [
    {
      name: 'Visa',
      icon: '/images/payments/visa.svg',
    },
    {
      name: 'Mastercard',
      icon: '/images/payments/mastercard.svg',
    },
    {
      name: 'Apple pay',
      icon: '/images/payments/apple-pay.svg',
    },
    {
      name: 'Google pay',
      icon: '/images/payments/google-pay.svg',
    },
  ],
};
